import { render, staticRenderFns } from "./AutoChatSetting.vue?vue&type=template&id=802fe256"
import script from "./AutoChatSetting.vue?vue&type=script&lang=js"
export * from "./AutoChatSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports